module.exports = __webpack_public_path__ + "static/images/styles/images/icons/info-big.2412453f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/info-big.png
// module id = 3640
// module chunks = 11